import React, { useState } from "react";
import { Link, NavLink, Outlet, Navigate, useNavigate } from "react-router-dom";
import { LogOut, Menu, X, Home, Users, Trophy, FileText, Image as ImgIcon, Settings as SettIcon, Newspaper, Activity, CreditCard, Calendar } from "lucide-react";
import { useAuth } from "../../lib/auth";
import { LOGO_URL } from "../../lib/constants";

const NAV = [
    { to: "/admin", label: "Tableau", icon: Home, end: true, role: "any" },
    { to: "/admin/horaire", label: "Horaire", icon: Calendar, role: "admin" },
    { to: "/admin/scores", label: "Scores", icon: Activity, role: "any" },
    { to: "/admin/teams", label: "Équipes", icon: Trophy, role: "admin" },
    { to: "/admin/rosters", label: "Rosters", icon: Users, role: "admin" },
    { to: "/admin/registrations", label: "Inscriptions", icon: CreditCard, role: "admin" },
    { to: "/admin/news", label: "Nouvelles", icon: Newspaper, role: "admin" },
    { to: "/admin/partners", label: "Partenaires", icon: FileText, role: "admin" },
    { to: "/admin/gallery", label: "Galerie", icon: ImgIcon, role: "admin" },
    { to: "/admin/users", label: "Utilisateurs", icon: Users, role: "admin" },
    { to: "/admin/settings", label: "Paramètres", icon: SettIcon, role: "admin" },
];

export default function AdminLayout() {
    const { user, loading, logout } = useAuth();
    const nav = useNavigate();
    const [open, setOpen] = useState(false);

    if (loading) return <div className="min-h-screen flex items-center justify-center text-white/60">Chargement...</div>;
    if (!user) return <Navigate to="/admin/login" replace />;

    const visibleNav = NAV.filter(n => n.role === "any" || user.role === "admin");

    const doLogout = () => { logout(); nav("/admin/login"); };

    return (
        <div className="min-h-screen bg-[#0a0a0a] flex flex-col" data-testid="admin-layout">
            <header className="sticky top-0 z-40 bg-black/90 backdrop-blur-xl border-b border-white/10">
                <div className="px-3 sm:px-6 h-16 flex items-center justify-between gap-2 sm:gap-4">
                    <div className="flex items-center gap-3 min-w-0">
                        <button className="lg:hidden text-white shrink-0" onClick={() => setOpen(v => !v)} data-testid="admin-menu-toggle">{open ? <X size={24} /> : <Menu size={24} />}</button>
                        <Link to="/admin" className="flex items-center gap-2 min-w-0">
                            <img src={LOGO_URL} alt="" className="h-9 w-9 shrink-0" />
                            <div className="min-w-0">
                                <div className="font-display text-xl tracking-widest leading-none hidden sm:block">DÉFI ULTIME</div>
                                <div className="text-[10px] tracking-[0.3em] text-[#4FE0D5] uppercase">Admin</div>
                            </div>
                        </Link>
                    </div>
                    <div className="flex items-center gap-2 sm:gap-3 text-xs shrink-0">
                        <span className="hidden md:inline label-mini">{user.role}</span>
                        <span className="hidden sm:inline text-white/70 truncate max-w-[180px]">{user.email}</span>
                        <button data-testid="admin-logout" onClick={doLogout} className="btn-ghost flex items-center gap-2 px-2 sm:px-3"><LogOut size={14} /> <span className="hidden sm:inline">Déconnexion</span></button>
                    </div>
                </div>
            </header>
            <div className="flex flex-1">
                <aside className={`${open ? "block" : "hidden"} lg:block w-64 border-r border-white/10 bg-black/60 backdrop-blur-md p-4 lg:sticky lg:top-16 lg:h-[calc(100vh-4rem)]`}>
                    <nav className="grid gap-1">
                        {visibleNav.map(n => (
                            <NavLink
                                key={n.to}
                                to={n.to}
                                end={n.end}
                                onClick={() => setOpen(false)}
                                data-testid={`admin-nav-${n.to.replace("/admin", "").replace("/", "") || "dashboard"}`}
                                className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 font-display text-sm tracking-widest uppercase border-l-2 ${isActive ? "border-[#7FD93C] text-[#7FD93C] bg-white/5" : "border-transparent text-white/70 hover:text-white hover:bg-white/5"}`}
                            >
                                <n.icon size={16} /> {n.label}
                            </NavLink>
                        ))}
                    </nav>
                </aside>
                <main className="flex-1 p-4 sm:p-6 lg:p-8 overflow-x-auto">
                    <Outlet />
                </main>
            </div>
        </div>
    );
}
